import React, {useEffect, useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { faMale, faFemale, faShoePrints, faChild } from '@fortawesome/free-solid-svg-icons';
import AuthService from "../services/auth/auth_service";
import Category from "../categories/category";
import {useNavigate} from "react-router";
import Category1 from "../categories/category1"; // Import the icons you need

 const categories = [
  { name: 'All', icon: null },
  { name: 'Watch', icon: 'bx bxs-watch' },
  { name: 'Women', icon: 'bx bx:glasses' },
  { name: 'Shoes', icon: faShoePrints },
  { name: 'Children', icon: faChild },
  { name: 'Boy', icon: faChild },
  { name: 'Girl', icon: faChild }
];

function Home() {
const navigate = useNavigate()



   const [activeTab, setActiveTab] = useState(1);
   const [subCategory0, setSubCategory0] = useState([]);
    const [activeTabValue, setActiveTabValue] = useState('All');
   const [categoryOg, setCategoryOg] = useState('All');
   const [subCategory1, setSubCategory1] = useState([]);
   const [categoryOg1, setCategoryOg1] = useState('All');
    const [intro, setIntro] = useState([]);




     const [isSwiperEnabled, setIsSwiperEnabled] = useState(false);

  useEffect(() => {
    // Check screen width and enable/disable Swiper accordingly
    const screenWidth = window.innerWidth;
    setIsSwiperEnabled(screenWidth < 768); // Enable Swiper for screens smaller than 768px (small devices)
  }, []);



   const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AuthService.loadAllCategories()
      .then((response) => {
        setData(response.data.results);
        console.log(response.data.results)
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false); // Set loading to false even in case of an error
      });
  }, []); // The


  const setCategory0 = (id, name) => {
    AuthService.loadAllSubCategoryByCategoryId(id)
      .then((response) => {
        setSubCategory0(response.data.results);
        setCategoryOg(name);

        console.log('gggg', response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false); // Set loading to false even in case of an error
      });
  }


  const setCategory1 = (id, name) => {
    AuthService.loadAllSubCategoryByCategoryId(id)
      .then((response) => {
        setSubCategory1(response.data.results);
        setCategoryOg1(name);

        console.log('gggg', response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false); // Set loading to false even in case of an error
      });
  }


  useEffect(()=>{
      AuthService.loadIntro()
      .then((response) => {
        setIntro(response.data.results);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [])







  /*const previousScrollY = window.scrollY;
   const current = previousScrollY

// ... Code to navigate to the next page ...

// When returning to the previous page, scroll back to the previous position
window.scrollTo({
  top: current
});*/



  return (
<div   onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}>


 {/* <header className="header" id="header">
    <nav className="nav container">
      <a href="#" className="nav__logo">
        <i className='bx bxs-watch nav__logo-icon'></i> Rolex
      </a>

      <div className="nav__menu" id="nav-menu">
        <ul className="nav__list">
          <li className="nav__item">
            <a href="#home" className="nav__link active-link">Home</a>
          </li>
          <li className="nav__item">
            <a href="#featured" className="nav__link">Featured</a>
          </li>
          <li className="nav__item">
            <a href="#products" className="nav__link">Products</a>
          </li>
          <li className="nav__item">
            <a href="#new" className="nav__link">New</a>
          </li>
        </ul>

        <div className="nav__close" id="nav-close">
          <i className='bx bx-x'></i>
        </div>
      </div>

      <div className="nav__btns">

        <i className='bx bx-moon change-theme' id="theme-button"></i>

        <div className="nav__shop" id="cart-shop">
          <i className='bx bx-shopping-bag'></i>
        </div>

        <div className="nav__toggle" id="nav-toggle">
          <i className='bx bx-grid-alt'></i>
        </div>
      </div>
    </nav>
  </header>
*/}

{/*  <div className="cart" id="cart">
    <i className='bx bx-x cart__close' id="cart-close"></i>

    <h2 className="cart__title-center">My Cart</h2>

    <div className="cart__container">
      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/featured1.png" alt="" className="cart__img"/>
        </div>

        <div className="cart__details">
          <h3 className="cart__title">Jazzmaster</h3>
          <span className="cart__price">$1050</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>

      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/featured3.png" alt="" className="cart__img"/>

        </div>

        <div className="cart__details">
          <h3 className="cart__title">Rose Gold</h3>
          <span className="cart__price">10,000Tsh</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>

      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/new1.png" alt="" className="cart__img"/>
        </div>

        <div className="cart__details">
          <h3 className="cart__title">Longines Rose</h3>
          <span className="cart__price">$980</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>
    </div>

    <div className="cart__prices">
      <span className="cart__prices-item">3 items</span>
      <span className="cart__prices-total">$2880</span>
    </div>
  </div>*/}






      <main className="main">

          {intro.map((d,i)=>{
              return(
                  <section key={d.id} className="home" id="home">
          <div className="home__container container grid">
            <div className="home__img-bg lg:mt-40">
              <img src={d.photo} alt="" className="home__img mt-10"/>
            </div>

            <div className="home__social">
              <a href="https://www.facebook.com/" target="_blank" className="home__social-link">
                Facebook
              </a>
              <a href="https://twitter.com/" target="_blank" className="home__social-link">
                Twitter
              </a>
              <a href="https://www.instagram.com/" target="_blank" className="home__social-link">
                Instagram
              </a>
            </div>

            <div className="home__data pb-16">
              <h1 className="home__title text-center">{d.title} <br/> {d.title2} </h1>
              <p className="home__description">
                  {d.description}
               {/* Latest arrival of the new imported products,
                with a modern and resistant design all together found here.*/}
              </p>
               <center>
                    <span onClick={() => navigate('/package')}  className="button button--small "><i className='bx bx-package mr-2'></i>
                        Ona package yote
                    </span>
               </center>
              <span className="home__price"></span>

             {/* <div className="home__btns">
                <a href="#" className="button button--gray button--small">
                  Discover
                </a>

                <button className="button home__button">ADD TO CART</button>
              </div>*/}
            </div>
          </div>
        </section>
              )
          })}


        <section className="featured section container" id="featured">
          <h2 className="section__title">
            Products
          </h2>



         <div className="category-selector">
  {isSwiperEnabled ? (
    /*<div style={{ width: '40%' }}>
      <Swiper slidesPerView="auto" style={{ overflow: 'visible' }}>
        {data.map((category) => (
          <SwiperSlide key={category.name}>
            <button
                onClick={()=>setCategory(category.name)}
              style={{ minWidth: '120px' }}
              className="flex items-center justify-center bg-blue-500 text-white inline-block px-4 py-2 rounded-md mx-2 my-1 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300 transition duration-300 ease-in-out"
            >
              {/!*{category.icon && (
                <FontAwesomeIcon
                  icon={category.icon}
                  className="text-xl mr-2" // Adjust the icon size and spacing as needed
                />
              )}*!/}
              <span className={`${category.icon}`}></span>
              {category.name}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>*/

      <div style={{ width: '30%' }}>
      <Swiper slidesPerView="auto" style={{ overflow: 'visible' }}>

        {data.map((category, index) => (
          <SwiperSlide key={index}>
           <button
  type="button"
  style={{
    width: '90px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    spaceBetween:'50px'
  }}
                onClick={() => {setActiveTab(category.id); setCategory0(category.id, category.name); setActiveTabValue('All')}}
              type="button"
              className={` ${
                activeTab === category.id
                  ? 'hs-tab-active:bg-blue-500 bg-blue-900 hs-tab-active:border-b-transparent hs-tab-active:text-white dark:hs-tab-active:bg-gray-100 dark:hs-tab-active:border-b-gray-800 dark:hs-tab-active:text-white'
                  : 'bg-red-100'
              } -mb-px py-3 px-4 text-center inline-flex items-center gap-2  text-sm font-medium text-center border text-gray-500 rounded-t-lg hover:text-gray-700 dark:border-gray-700 dark:text-gray-400 dark:hover:text-gray-300`}

              role="tab"
            >
              <span className={`${category.icon}  mr-0.1`}></span>
              {category.name}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>

    </div>

  ) : (
    <div className="md:flex cursor-pointer">
      {data.map((category) => (
        <div
  key={category.name}
  className={`flex items-center px-4 py-2  hover:border-blue-500  ${
    activeTab === category.id ? 'border-blue-500 text-blue-500  border-b-2  ' : ' '
  }`}
  onClick={() => {setActiveTab(category.id); setCategory0(category.id, category.name); setActiveTabValue('All')}}
>
          {category.icon && (
            /*<FontAwesomeIcon
              icon={category.icon}
              className="text-xl mr-2 " // Adjust the icon size and spacing as needed
            />*/
              <span className={`${category.icon}`}></span>
          )}
          {category.name}
        </div>
      ))}
    </div>
  )}
</div>












          {/*<div className="featured__container grid bg-dark ">
            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag">Sale</span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600">Sectional Sofa</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">$78900</p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>


            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag">Sale</span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600">Sectional Sofa</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">$78900</p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>

            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag">Sale</span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600">Sectional Sofa</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">$78900</p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>


            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-01.jpg") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag">Sale</span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600">Sectional Sofa</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">$78900</p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>

            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("https://tailwindui.com/img/ecommerce-images/shopping-cart-page-04-product-02.jpg") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag text-center">Available <i style={{visibility:'hidden'}}>sh</i></span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600">Sectional Sofa</p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800">$78900</p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>


            <article className="featured__card " style={{
                background: 'rgba(255, 255, 255, 0.7) url("assets/img/home.png") center/contain no-repeat',
                padding: '20px',
              backgroundColor:'#fff'

            }}>
              <span className="featured__tag">Not Available</span>

                <div className=" sm:p-35 py-36 px-10 flex justify-center items-center">

                        <div className="absolute sm:top-8 top-4 left-4 sm:left-8 flex justify-start items-center text-center   flex-col space-y-2">
                            <div className="flex justify-start items-center text-center  flex-col space-y-2">
                                <p className="group-hover:opacity-60 transition duration-500 mx-12 text-xl leading-5 text-gray-600"></p>
                            </div>
                            <div>
                                <p className="group-hover:opacity-60 transition duration-500 text-xl font-semibold leading-5 text-gray-800"></p>
                            </div>
                        </div>

                                      </div>
              <button className="button featured__button">ADD TO CART</button>
            </article>



          </div>*/}
        </section>






        <Category  subCategory0={subCategory0} categoryOg={categoryOg} activeTabValue={activeTabValue} />
       {/* <Category1 subCategory0={subCategory1} categoryOg={categoryOg1} />*/}






        <section className="newsletter section container lg:mb-0 mb-10">


          <div className="newsletter__bg  ">{/*grid*/}
            <div>
              <h2 className="newsletter__title">Subscribe Our <br/> Maokoto Og</h2>
              <p className="newsletter__description">
                Don't miss out on your discounts. Subscribe to our email
                Maokoto26@gmail.com to get the best offers, discounts, coupons,
                gifts and much more.
              </p>
            </div>

            <div action="" className="newsletter__subscribe mt-10">
              <input type="email" placeholder="Enter your email" className="newsletter__input"/>
                <button className="button">
                  SUBSCRIBE
                </button>
            </div>
          </div>
        </section>


      {/*  <section className="bg-gradient-to-r from-purple-500 to-pink-500 py-16">
  <div className="container mx-auto px-4 lg:grid lg:grid-cols-2 gap-8 items-center">
    <div className="text-center lg:text-left">
      <h2 className="text-3xl lg:text-4xl font-semibold text-white mb-4">Subscribe to Our Newsletter</h2>
      <p className="text-lg lg:text-xl text-gray-200 mb-8">
        Stay updated with the latest trends and exclusive offers. Join our newsletter and be part of the Maokoto Og community.
      </p>
    </div>

    <form className="lg:w-3/4">
      <div className="flex items-center">
        <input
          type="email"
          placeholder="Enter your email"
          className="bg-white border border-gray-300 rounded-l px-4 py-3 focus:outline-none focus:ring focus:border-blue-300 w-full"
        />
        <button className="bg-blue-500 hover:bg-blue-600 text-white rounded-r px-6 py-3 focus:outline-none focus:ring focus:border-blue-300">
          SUBSCRIBE
        </button>
      </div>
    </form>
  </div>
</section>*/}

      </main>



</div>
  );
}

export default Home;
